import { render, staticRenderFns } from "./ResultStatus.vue?vue&type=template&id=573b322e&scoped=true&lang=pug&"
import script from "./ResultStatus.vue?vue&type=script&lang=js&"
export * from "./ResultStatus.vue?vue&type=script&lang=js&"
import style0 from "./ResultStatus.vue?vue&type=style&index=0&id=573b322e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573b322e",
  null
  
)

export default component.exports